export default __webpack_public_path__ + "img/20.dce7c6.png";